let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ftLU")).then(() => parcelRequire('aEI9p'));